import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-num_Circular",
  "use": "icon-num_Circular-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-num_Circular\">\r\n  <defs>\r\n    <style type=\"text/css\"></style>\r\n  </defs>\r\n  <g transform=\"translate(-50,-50)scale(1.1,1.1)\">\r\n    <path d=\"M62 512c0 248.528 201.472 450 450 450s450-201.472 450-450c0-248.528-201.472-450-450-450-248.528 0-450 201.472-450 450z\" fill=\"#EDF0F5\" p-id=\"1293\">\r\n    </path>\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol